import { h, Component } from "preact";

class DropdownProjectsMenu extends Component {
  constructor(props) {
    super(props);

    this.state = {
      value: {}
    };

    this.onInputValueChange = this.onInputValueChange.bind(this);
    this.onClick = this.onClick.bind(this);
  }

  onInputValueChange(e) {
    this.setState({
      value: {
        value: e.target.value,
        label: e.target.value
      }
    });
  }

  onClick(e, value) {
    e.stopPropagation();
    e.preventDefault();

    this.props.onChange(value);
  }

  render({ values = {}, open, style, itemStyle, menuName }) {
    const keys = Object.keys(values);

    return (
      <nav
        class={`user-widget__dropdown__menu ${open &&
          "user-widget__dropdown__menu--open"} ${menuName}`}
        style={style}
      >
        {keys.length ? keys.map(section => (
          <ul role="menu">
            <li class="user-widget__dropdown__menu__section" role="menuitem">{section}</li>
            {values[section].map(l => (
              <li role="menuitem">
                <a
                  class="user-widget__dropdown__menu__list_item"
                  style={itemStyle}
                  href={l.uri}
                  aria-label="projects"
                  rel="noopener noreferrer"
                >
                  {l.label || "Untitled project"}
                </a>
              </li>
            ))}
          </ul>
        )) : <div
          class="user-widget__dropdown__menu__list_item">
            No projects
        </div>}
      </nav>
    );
  }
}

export default DropdownProjectsMenu;



// WEBPACK FOOTER //
// ./src/DropdownProjectsMenu.js